import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderStatus'
})
export class OrderStatusPipe implements PipeTransform {

  transform(value: any, args?: any): any {

  }

}


//零售商家开团活动
@Pipe({
  name: 'couponType'
})
export class CouponStatusPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let type;
    switch (Number(value)) {
      case 0:
        type = '实体店';
        break;
      case 1:
        type = '线上店';
        break;
      default:
        type = '';
    }

    return type;
  }

}



